import React from 'react'
import './aboutUs.styles.scss'
import About from '../../Assets/about.jpg';
import Ending from '../../Components/Ending/Ending';
import puzzle from '../../Assets/puzzle.png'
import result from '../../Assets/result.png'
import innovation from '../../Assets/innovation.png'
import sharing from '../../Assets/sharing.png'
import { ReactComponent as Cart } from '../../Assets/cart.svg'
import { ReactComponent as Check } from '../../Assets/check.svg'
import { ReactComponent as Model } from '../../Assets/model.svg'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async';

const AboutUs = () => {
    const { t } = useTranslation();

    return (
        <div className='about'>
            <Helmet>
                <meta itemProp="name" content="Chi siamo" />
                <meta itemProp='description' content="Fondata nel 2012 da Alessandro Tiretta, l'azienda ha una lunga esperienza nel settore e offre un'ampia gamma di soluzioni per aiutare le aziende..." />
            </Helmet>
            <div className='text-container'>
                <img src={About} alt="About Us" />
                <div className='text'>
                    <label aria-label={`${t("about.title1")} ${t("about.title2")}`}>
                        {t("about.title1")}<br />
                        {t("about.title2")}
                    </label>
                </div>
            </div>
            <div className='stories' style={{ backgroundColor: '#F2F8EA' }}>
                <div>
                    <label aria-label={`${t("about.founded1")} ${t("about.founded2")}`}>
                        {t("about.founded1")}<br /> <br />
                        {t("about.founded2")}
                    </label>
                </div>
                <div>
                    <Cart className='picture' />
                </div>
            </div>
            <div className='stories left'>
                <div>
                    <img src={puzzle} alt="puzzle.png" />
                </div>
                <div>
                    <label>
                        <label aria-label={t("about.whatwedo")} style={{ fontSize: '30px' }}>{t("about.whatwedo")}</label><br /><br />
                        <label aria-label={t("about.whatwedo1")}>{t("about.whatwedo1")}</label><br /><br />
                        <label aria-label={t("about.whatwedo2")}>{t("about.whatwedo2")}</label><br /><br />
                    </label>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div>
                            <label aria-label={t("about.whatwedo.check1")}>{t("about.whatwedo.check1")}</label>
                        </div>
                    </div>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div>
                            <label aria-label={t("about.whatwedo.check2")}>{t("about.whatwedo.check2")}</label>
                        </div>
                    </div>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div>
                            <label aria-label={t("about.whatwedo.check3")}>{t("about.whatwedo.check3")}</label>
                        </div>
                    </div>
                    <div className='list'>
                        <div>
                            <Check />
                        </div>
                        <div>
                            <label aria-label={t("about.whatwedo.check4")}>{t("about.whatwedo.check4")}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className='stories' style={{ backgroundColor: '#FBFBFA' }}>
                <div>
                    <label aria-label={`${t("about.ourmodel")} ${t("about.ourmodel.description")}`}>
                        <label style={{ fontSize: '30px' }}>{t("about.ourmodel")}</label><br /><br />
                        {t("about.ourmodel.description")}
                    </label>
                </div>
                <div>
                    <Model className='picture' />
                </div>
            </div>
            <div className='values'>
                <label aria-label={t("about.smartbip")}>
                    {t("about.smartbip")}
                </label>
                <div>
                    <label aria-label={t("about.ourvalues")}>{t("about.ourvalues")}</label>
                    <div className='card-container'>
                        <div className='card'>
                            <div className='image-container'>
                                <img src={result} alt="risultati.png" />
                            </div>
                            <div className='description-container'>
                                <label aria-label={t("about.ourvalues.title1")}>{t("about.ourvalues.title1")}</label>
                                <label aria-label={t("about.ourvalues.subtitle1")}>{t("about.ourvalues.subtitle1")}</label>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='image-container'>
                                <img src={sharing} alt="sharing.png" />
                            </div>
                            <div className='description-container'>
                                <label aria-label={t("about.ourvalues.title2")}>{t("about.ourvalues.title2")}</label>
                                <label aria-label={t("about.ourvalues.subtitle2")}>{t("about.ourvalues.subtitle2")}</label>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='image-container'>
                                <img src={innovation} alt="innovation.png" />
                            </div>
                            <div className='description-container'>
                                <label aria-label={t("about.ourvalues.title3")}>{t("about.ourvalues.title3")}</label>
                                <label aria-label={t("about.ourvalues.subtitle3")}>{t("about.ourvalues.subtitle3")}</label>
                            </div>
                        </div>
                        <div className='card'>
                            <div className='image-container'>
                                <img src={sharing} alt="sharing.png" />
                            </div>
                            <div className='description-container'>
                                <label aria-label={t("about.ourvalues.title4")}>{t("about.ourvalues.title4")}</label>
                                <label aria-label={t("about.ourvalues.subtitle4")}>{t("about.ourvalues.subtitle4")}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Ending text={t("about.ending")} />
        </div>
    )
}

export default AboutUs